<template>
    <button ref="droneButtonRef" class="drone-button" v-bind="$attrs" type="button" @click="removeFocus()">
        <div v-if="glyph" class="glyph">
            <slot />
            <glyph-icon :type="glyph" />
        </div>
        <div v-else class="text">
            <slot />
        </div>
    </button>
</template>

<script setup>
import { ref } from 'vue';
import GlyphIcon from '../icons/glyphs/GlyphIcon.vue';

const props = defineProps({
    glyph: {
        type: String,
        default: null,
    },
});

const droneButtonRef = ref(null);

function removeFocus() {
    requestAnimationFrame(() => {
        droneButtonRef.value?.blur();
    });
}
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;
@use 'ihunter-pathfinder/styles/buttons' as PathfinderButton;

.drone-button {
    @include PathfinderButton.Button;

    color: var(--action);
    background: transparent;
    padding: Pathfinder.$space-100 Pathfinder.$space-200;
    border-radius: Pathfinder.$radius-400;
    height: Pathfinder.$button-height-small;
    width: fit-content;

    ::v-deep(svg) {
        fill: var(--action);
    }

    &:hover {
        background: var(--action-glowshift);
    }

    &:focus-visible {
        background: var(--action-glowshift-alt);
    }

    &:active,
    &.active {
        // tapped
        background: var(--action-glowshift-alt);
        color: var(--action-alt);

        ::v-deep(svg) {
            fill: var(--action-alt);
        }
    }

    &:disabled {
        // inactive
        background: var(--surface-glowbox);
        color: var(--on-surface-glowbox-alt);
        cursor: auto;

        ::v-deep(svg) {
            fill: var(--on-surface-glowbox-alt);
        }
    }

    .glyph {
        display: flex;
        align-items: center;
        gap: Pathfinder.$space-150;

        ::v-deep(svg) {
            height: Pathfinder.$icon-micro;
            width: Pathfinder.$icon-micro;
        }
    }

    .label:empty,
    .glyph:empty {
        display: none;
    }
}
</style>
